import { createRouter, createWebHistory } from "vue-router";
import feedback from "@/services/feedback";
import store from "@/store";

const routes = [
  { path: "/", name: "home", component: () => import("../views/HomePage.vue") },
  { path: "/login", name: "LoginPage", component: () => import("../views/AuthAccess.vue") },
  { path: "/articleList", name: "articleList", component: () => import("../views/ArticleArchive.vue") },
  { path: "/writeArticle", name: "writeArticle", component: () => import("../views/ArticleStudio.vue"), meta: { requiresAuth: true } },
  { path: "/article/:id", name: "ArticleDetail", component: () => import("../views/ArticleReader.vue") },
  { path: "/imgWall", name: "imgWall", component: () => import("../views/PhotoGallery.vue") },
  { path: "/personalCenter", name: "personalCenter", component: () => import("../views/AccountWorkspace.vue"), meta: { requiresAuth: true } },
  { path: "/editArticleById/:id", name: "editArticleById", component: () => import("../views/ArticleStudio.vue"), meta: { requiresAuth: true } },
  { path: "/music", name: "music", component: () => import("../views/MusicRoom.vue") },
  { path: "/systemManage", name: "systemManage", component: () => import("../views/systemManage.vue"), meta: { requiresAuth: true, requiresAdmin: true } },
  { path: "/error", name: "error", component: () => import("../views/error.vue") },
  { path: "/tools", name: "tools", component: () => import("../views/tools.vue") },
  { path: "/:pathMatch(.*)*", name: "notFound", component: () => import("../views/error.vue") },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, _from, savedPosition) {
    if (savedPosition) return savedPosition;
    if (to.hash) return { el: to.hash, top: 104, behavior: "smooth" };
    return { top: 0, left: 0 };
  },
});

function readStoredUser() {
  try { return JSON.parse(window.localStorage.getItem("user") || "null"); }
  catch (error) { return null; }
}

router.beforeEach((to) => {
  store.commit("checkTokenExpiration");
  const hasToken = store.getters.isTokenValid;
  if (to.meta.requiresAuth && !hasToken) {
    feedback.warning({ title: "需要登录", message: "登录后才能继续访问该功能。", duration: 3600 });
    return { path: "/", query: { login: "required", redirect: to.fullPath }, replace: true };
  }

  if (to.meta.requiresAdmin && readStoredUser()?.role !== "ADMIN") {
    feedback.warning({ title: "无权访问", message: "当前账户没有后台管理权限。", duration: 3600 });
    return { path: "/", replace: true };
  }
  return true;
});

export default router;
